<div class="content-container">
  <div class="container-left">
    <div class="rack-container" [ngClass]="{'rack-container-empty' : shelfArrLeft.length === 0, 'rack-container': shelfArrLeft.length > 0}"
      *ngIf="rack?.seperator === true; else elseBlock">
      <div class="rack-left">
            <div *ngFor="let shelf of shelfArrLeft.slice().reverse();let i = index" class="shelf-item">
          <h3>Baggage Compartment {{shelfArrLeft.length - i}}</h3>
          <mat-form-field appearance="outline" class="shelf-field">
            <mat-label>Clear width</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.width" (ngModelChange)="shelf.box.width = $event" class="text-right">
          </mat-form-field>
          <mat-form-field appearance="outline" class="shelf-field">
            <mat-label>Compartment height</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.height" (ngModelChange)="shelf.box.height = $event" class="text-right">
          </mat-form-field>
          <mat-form-field appearance="outline" class="shelf-field">
            <mat-label>Depth of compartment</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.length" (ngModelChange)="shelf.box.length = $event" class="text-right">
          </mat-form-field>
        </div>
      </div>
      <div class="rack-right">
        <div *ngFor="let shelf of shelfArrRight.slice().reverse();let i = index" class="shelf-item">
          <h3>Baggage Compartment {{shelfArrLeft.length - i}}</h3>
          <mat-form-field appearance="outline" class="shelf-field">
            <mat-label>Clear width</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.width" (ngModelChange)="shelf.box.width = $event" class="text-right">
          </mat-form-field>
          <mat-form-field appearance="outline" class="shelf-field">
            <mat-label>Compartment height</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.height" (ngModelChange)="shelf.box.height = $event" class="text-right">
          </mat-form-field>
          <mat-form-field appearance="outline" class="shelf-field">
            <mat-label>Depth of compartment</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.length" (ngModelChange)="shelf.box.length = $event" class="text-right">
          </mat-form-field>
        </div>
      </div>
    </div>
    <ng-template #elseBlock>
      <div class="rack-container" [ngClass]="{'rack-container-empty' : shelfArrLeft.length === 0, 'rack-container': shelfArrLeft.length > 0}">
        <div class="shelf-container">
          <div *ngFor="let shelf of shelfArrLeft.slice().reverse();let i = index" class="shelf-item">
            <h3>Baggage Compartment {{shelfArrLeft.length - i}}</h3>
            <mat-form-field appearance="outline" class="shelf-field">
              <mat-label>Clear width</mat-label>
              <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.width" (ngModelChange)="shelf.box.width = $event" class="text-right">
            </mat-form-field>
            <mat-form-field appearance="outline" class="shelf-field">
              <mat-label>Compartment height</mat-label>
              <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.height" (ngModelChange)="shelf.box.height = $event" class="text-right">
            </mat-form-field>
            <mat-form-field appearance="outline" class="shelf-field">
              <mat-label>Depth of compartment</mat-label>
              <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="shelf?.box?.length" (ngModelChange)="shelf.box.length = $event" class="text-right">
            </mat-form-field>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="container-right">
    <div class="properties">
      <mat-form-field *ngIf="showFeatureSecurity" class="form-field">
        <mat-label>Security type</mat-label>
        <mat-select class="text-right" [value]="rack.security" (selectionChange)="changeSecurityType($event.value)">
          <mat-option class="select-without-checkbox" *ngFor="let securityType of securityTypes" [value]="securityType.id">
            {{securityType.name}}
          </mat-option> 
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Overall height</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="baseDimension?.box?.height" (ngModelChange)="baseDimension.box.height = $event"
          class="text-right">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Compartment height from the floor</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="podest?.height" (ngModelChange)="podest.height = $event" class="text-right">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Wall thickness</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="rack?.wallThickness" (ngModelChange)="rack.wallThickness = $event"
          class="text-right">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Floor thickness</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="rack?.floorThickness" (ngModelChange)="rack.floorThickness = $event"
          class="text-right">
      </mat-form-field>
    </div>
    <div class="properties-buttons">
      <button mat-raised-button class="margin-right color" [disabled]="isRemoveShelfDisabled" (click)="removeShelf()">
        <mat-icon class="margin-right">remove</mat-icon>Remove Compartment
      </button>
      <button mat-raised-button class="margin-right color" (click)="addShelf()">
        <mat-icon class="margin-right">add_box</mat-icon>Add Compartment
      </button>
    </div>
  </div>
</div>